import { ThemeProvider } from 'styled-components'
import { DarkTheme } from './Themes/dark'
import Titulo from './containers/Header'
import EstiloGlobal from './styles'
import Sobre from './containers/Sobre'
import Aulas from './containers/Aulas'
import { useState } from 'react'
import DetalhesAula from './containers/DetalhesAula'
import Contato from './containers/Contato'
import Videos from './containers/Videos'
import Footer from './containers/Footer'

interface Instrumento {
  nome: string
  img: string
  descricao: string
}

function App() {
  const [instrumentoSelecionado, setInstrumentoSelecionado] =
    useState<Instrumento | null>(null)

  return (
    <ThemeProvider theme={DarkTheme}>
      <EstiloGlobal />
      <Titulo />
      <Sobre />
      <Aulas aoSelecionar={setInstrumentoSelecionado} />
      <DetalhesAula
        key={instrumentoSelecionado?.nome}
        instrumento={instrumentoSelecionado}
      />
      <Videos />
      <Contato />
      <Footer />
    </ThemeProvider>
  )
}

export default App
